import icons from "../icons";

const footerConfigs = {
  socialMedia: [
    {
      title: "تلگرام",
      icon: icons.telegram,
    },
    {
      title: "اینستاگرام",
      icon: icons.instagram,
    },
    {
      title: "توییتر",
      icon: icons.twitter,
    },
    {
      title: "واتساپ",
      icon: icons.whatsApp,
    },
  ],

  links: [
    {
      title: "درباره‌ما",
      link: "/about-us",
    },
    {
      title: "کارمزد",
      link: "/commissions",
    },
    {
      title: "قوانین و مقررات",
      link: "/terms-and-conditions",
    },
    {
      title: "راهنمای استفاده",
      link: "/guide",
    },
  ],
};

export default footerConfigs;
